// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAvHM-PiM8xbRVXW0wdklC6z-JlKYC4TZU",
  authDomain: "clwbnawa.firebaseapp.com",
  projectId: "clwbnawa",
  storageBucket: "clwbnawa.appspot.app",
  messagingSenderId: "642427851115",
  appId: "1:642427851115:web:28ab09562bb280a76afc2e",
  measurementId: "G-079BQ8H5F0",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); // ✅ this is what your Firestore functions will use

export default app;
